var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Parallax.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Parallax.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Parallax/Parallax.jinja
// module id = 105
// module chunks = 0